const initialState = {
    imcdraftsave: {},
    clientdraftsave: {},
};

const DraftReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'IMCDraftSave':
            return {
                ...state,
                imcdraftsave: action.payload,
            };
        case 'ClientDraftSave':
            return {
                ...state,
                clientdraftsave: action.payload,
            };
        default:
            return state;
    }
};

export default DraftReducer;
